<template>
  <div>
    <tsl-card :cardList="cardList">
      <template v-slot:operational>
        <div class="operational-audit">
          <div class="item" v-for="(item, index) in menuList" :key="index">
            <devops-card :name="item.name" :value="item.value" :path="item.path"></devops-card>
          </div>
        </div>
      </template>
      <template v-slot:topRight>
        <more-arrow path="/dashboard/devops/audit/overview" />
      </template>
    </tsl-card>
  </div>
</template>
<script>
import Card from "@/components/tsl-card/index.vue";
import Dcard from "@/components/dashboard/devops/devops-card.vue";
import More from "@/components/more-arrow/index";
import { reactive, ref } from "vue";
export default {
  name: "operational-audit",
  components: {
    [Card.name]: Card,
    [Dcard.name]: Dcard,
    [More.name]: More
  },
  props: {
    data: Object
  },
  setup() {
    const menuList = ref([
      {
        name: "本地",
        value: 0,
        path: "/dashboard/devops/audit/local"
      },
      {
        name: "云端",
        value: 0,
        path: "/dashboard/devops/audit/cloud"
      }
    ]);
    const cardList = reactive([
      {
        name: "operational",
        title: "操作审计",
        topRight: "topRight"
      }
    ]);
    return {
      cardList,
      menuList
    };
  }
};
</script>
<style scoped lang="less">
.operational-audit {
  display: flex;
  .item {
    width: 50%;
    margin-right: 16px;
  }
  .item:nth-child(even) {
    margin-right: 0;
  }
}
</style>
